import React from 'react'
import classNames from 'classnames'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { IconWithText } from '@share/components'

import iconTop from '@assets/html/dist/img/shop-ui_icon_top.png'
import iconShopInfo from '@assets/html/dist/img/shop-ui_icon_shopinfo.png'
import iconMenu from '@assets/html/dist/img/shop-ui_icon_menu.png'
import iconLive from '@assets/html/dist/img/shop-ui_icon_live.png'
import iconVideosManager from '@assets/html/dist/img/shop-ui_icon_movie-management.png'
import iconVideoRequest from '@assets/html/dist/img/shop-ui_icon_rightarrow.png'
import iconTool from '@assets/html/dist/img/shop-ui_icon_tool.png'
import iconAccess from '@assets/html/dist/img/shop-ui_icon_access.png'
import iconHito from '@assets/html/dist/img/shop-ui_icon_hito.png'

type Props = {
  //
}

const MainMenu: React.FC<Props> = () => {
  const { t } = useTranslation()
  const location = useLocation()
  return (
    <ul className="list-unstyled components">
      <li className={classNames({ active: location.pathname.startsWith('/dashboard') })}>
        <Link to="/dashboard">
          <IconWithText
            icon={iconTop}
            label={t('leftSidebar.homeMenuLabel')}
          />
        </Link>
      </li>
      <li className={classNames({ active: location.pathname.startsWith('/store') })}>
        <Link to="/store">
          <IconWithText
            icon={iconShopInfo}
            label={t('leftSidebar.storeInfoMenuLabel')}
          />
        </Link>
      </li>
      <li className={classNames({ active: location.pathname.startsWith('/menu') })}>
        <Link to="/menu">
          <IconWithText
            icon={iconMenu}
            label={t('leftSidebar.menusMenuLabel')}
          />
        </Link>
      </li>
      <li className={classNames({ active: location.pathname.startsWith('/live') })}>
        <Link to="/live">
          <IconWithText
            icon={iconLive}
            label={t('leftSidebar.liveDeliveryMenuLabel')}
          />
        </Link>
      </li>
      <li className={classNames({ active: location.pathname.startsWith('/video') })}>
        <Link to="/video">
          <IconWithText
            icon={iconVideosManager}
            label={t('leftSidebar.videoManagementMenuLabel')}
          />
        </Link>
      </li>
      <li>
        <Link to="/">
          <IconWithText
            icon={iconVideoRequest}
            label={t('leftSidebar.videoRequestMenuLabel')}
          />
        </Link>
      </li>
      <li>
        <Link to="/">
          <IconWithText
            icon={iconTool}
            label={t('leftSidebar.externalToolSettingsMenuLabel')}
          />
        </Link>
      </li>
      <li className={classNames({ active: location.pathname.startsWith('/analytics') })}>
        <Link to="/analytics">
          <IconWithText
            icon={iconAccess}
            label={t('leftSidebar.analysisMenuLabel')}
          />
        </Link>
      </li>
      <li>
        <Link to="/">
          <IconWithText
            icon={iconHito}
            label={t('leftSidebar.userInfoMenuLabel')}
          />
        </Link>
      </li>
      <li>
        <Link to="/">
          <IconWithText
            icon={iconTool}
            label={t('leftSidebar.settingsMenuLabel')}
          />
        </Link>
      </li>
    </ul>
  )
}

export default MainMenu
